














import { Vue, Component, Prop, Model } from 'vue-property-decorator';

import IconArrow from '@/components/icons/Arrow.vue';

import { humanizeToRussian } from '@/utils/date/human';

@Component({
    components: {
        IconArrow,
    },
})
export default class StepInput extends Vue {
    @Model('update:duration', { default: 0 }) duration!: number
    @Prop({ default: 15 }) readonly step!: number
    @Prop({ default: 0 }) readonly min!: number
    
    get humanDuration() {
        return humanizeToRussian(this.duration);
    }

    updateDuration(duration: number) {
        this.$emit('update:duration', duration);
    }

    increase() {
        const duration = this.duration + this.step;

        this.updateDuration(duration);
    }

    decrease() {
        const duration = Math.max(this.duration - this.step, this.min);

        this.updateDuration(duration);
    }
}
